import { render, staticRenderFns } from "./RiskMatrixAdmin.vue?vue&type=template&id=3c60ced4"
import script from "./RiskMatrixAdmin.vue?vue&type=script&lang=js"
export * from "./RiskMatrixAdmin.vue?vue&type=script&lang=js"
import style0 from "./RiskMatrixAdmin.vue?vue&type=style&index=0&id=3c60ced4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports